import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import React from 'react'

export function EditorConfigTopBar(props: {
  itemLabel: string
  backLabel: string
  onBack: () => void
}) {
  return (
    <div className="template-editor-config-topbar">
      <button
        type="button"
        className="template-editor-config-back"
        onClick={props.onBack}
      >
        <ArrowBackIcon style={{fontSize: 18}} aria-hidden />
        <span>{props.backLabel}</span>
      </button>
      <p className="template-editor-config-item-type" title={props.itemLabel}>
        {props.itemLabel}
      </p>
    </div>
  )
}
